export default {
    namespaced: true,

    state: {
        selectedDevicesCount: []
    },

    mutations: {
        getSelectedDevicesCount(state, count) {
            state.selectedDevicesCount = count;
        }
    },
};